var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M16 3.039a6.8 6.8 0 0 1-1.89.518 3.26 3.26 0 0 0 1.443-1.813 6.6 6.6 0 0 1-2.08.794 3.28 3.28 0 0 0-5.674 2.243c0 .26.022.51.076.748a9.28 9.28 0 0 1-6.761-3.431 3.285 3.285 0 0 0 1.008 4.384A3.24 3.24 0 0 1 .64 6.078v.036a3.295 3.295 0 0 0 2.628 3.223 3.3 3.3 0 0 1-.86.108 3 3 0 0 1-.621-.056 3.31 3.31 0 0 0 3.065 2.285 6.6 6.6 0 0 1-4.067 1.399c-.269 0-.527-.012-.785-.045A9.23 9.23 0 0 0 5.032 14.5c6.036 0 9.336-5 9.336-9.334q0-.216-.012-.424A6.5 6.5 0 0 0 16 3.039"
  })));
};
export default SvgTwitter;